import { useEffect, useState } from 'react'

import type { TicketsItem } from '@/api/server/detail/dto/detailDto'

interface useParkinglotTicketsViewModel {
  tickets: TicketsItem[]
}

interface ParkinglotTicketsViewModel {
  texts: object
  states: { parkinglotTickets: TicketsItem[]; isShowAllTickets: boolean }
  setters: { setIsShowAllTickets: React.Dispatch<React.SetStateAction<boolean>> }
  handlers: object
}

const useParkinglotTicketsViewModel = ({ tickets }: useParkinglotTicketsViewModel): ParkinglotTicketsViewModel => {
  const [isShowAllTickets, setIsShowAllTickets] = useState(false)
  const [parkinglotTickets, setParkinglotTickets] = useState<TicketsItem[]>([])

  const getSortedTickets = (ticketsData: TicketsItem[]) => {
    const sortedTickets = ticketsData.sort((a, b) => {
      if (a.isOpen !== b.isOpen) {
        return (b.isOpen ? 1 : 0) - (a.isOpen ? 1 : 0)
      } else if (a.price !== b.price) {
        return a.price - b.price
      } else {
        return a.couponName.localeCompare(b.couponName)
      }
    })
    return sortedTickets
  }

  useEffect(() => {
    const result = getSortedTickets(tickets)
    setParkinglotTickets(result)
    setIsShowAllTickets(false)
  }, [tickets])

  useEffect(() => {
    if (!isShowAllTickets) {
      const result = getSortedTickets(tickets.slice(0, 4))
      setParkinglotTickets(result)
    } else {
      const result = getSortedTickets(tickets)
      setParkinglotTickets(result)
    }
  }, [isShowAllTickets, tickets])

  return {
    texts: {},
    states: { parkinglotTickets, isShowAllTickets },
    setters: { setIsShowAllTickets },
    handlers: {}
  }
}

export { useParkinglotTicketsViewModel }
